import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { ParametroService } from '@core/services/parametro.service';
import { APP_ANNUAL_PRICE, APP_REGULAR_PRICE } from '@shared/utils/constants';

const PRECIO_SUSCRIPCION_NUEVA_KEY = 'PRECIO_SUSCRIPCION_NUEVA';
const PRECIO_RENOVACION_SUSCRIPCION_KEY = 'PRECIO_RENOVACION_SUSCRIPCION';

@Injectable({
  providedIn: 'root',
})
export class AppPricingService {
  private readonly parametros = inject(ParametroService);

  readonly appAnnualPrice = signal<number>(APP_ANNUAL_PRICE);
  readonly appRegularPrice = signal<number>(APP_REGULAR_PRICE);

  /**
   * Loads the annual app subscription price (new subscription) from backend
   * parameter `PRECIO_SUSCRIPCION_NUEVA`. Falls back silently to the local
   * constant when the parameter is missing or the request fails.
   */
  loadAppAnnualPrice(): Observable<number> {
    return this.loadPriceParam(PRECIO_SUSCRIPCION_NUEVA_KEY, this.appAnnualPrice);
  }

  /**
   * Loads the regular (renewal) app subscription price from backend parameter
   * `PRECIO_RENOVACION_SUSCRIPCION`. Falls back silently to the local constant
   * when the parameter is missing or the request fails.
   */
  loadAppRegularPrice(): Observable<number> {
    return this.loadPriceParam(PRECIO_RENOVACION_SUSCRIPCION_KEY, this.appRegularPrice);
  }

  private loadPriceParam(
    clave: string,
    target: ReturnType<typeof signal<number>>
  ): Observable<number> {
    return this.parametros.getParametro(clave).pipe(
      tap((param) => {
        if (!param) return;
        const parsed = Number(param.valor);
        if (Number.isFinite(parsed) && parsed > 0) {
          target.set(parsed);
        }
      }),
      map(() => target()),
      catchError(() => of(target()))
    );
  }
}
